import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { MessageService } from '../message.service';

@Component({
    selector: 'app-token',
    templateUrl: './token.component.html',
    styleUrls: ['./token.component.css']
})
export class TokenComponent implements OnInit {
    clientId: any;
    loginName: any;
    cat1: number;
    cat2: number;
    cat3: number;
    cat4: number;
    cat2Alt: number;
    private respObject: any;
    srcType: string;
    typeId1: number;
    typeId2: number; 
    constructor(private _rest: RestApiService, private route: Router, private messageService: MessageService) {
    }

    ngOnInit() {
        this.clientId = 2;
        this.loginName = '20052575';
        this.cat1 = 65;
        this.cat2 = 66;
        this.typeId2 = 33;
        this.typeId1 = 32;
        this.cat3 = 247;
        this.cat4 = 248;
        this.cat2Alt = 0;
        // this.srcType = 'panel';
        this.messageService.clearSession();
        this.messageService.setClientId(this.clientId);
    }

    save() {
        this._rest.generateToken(this.clientId, this.loginName).subscribe((res) => {
            console.log("generateToken =========== >>>");
            
            this.respObject = res;
            if (this.respObject.success) {
                const data = this.respObject.details;
                window.location.href = this.messageService.API_ROOT + '/#/ticket/dashboard?token='
                    + data.token + '&clientId=' + this.clientId + '&name=' + data.loginName + '&cat1=' + this.cat1 +
                    '&cat2=' + this.cat2 + '&ticket_type1=' + this.typeId1 + '&ticket_type2=' + this.typeId2 + '&cat3=' +
                    this.cat3 + '&cat4=' + this.cat4 + '&callback=https://ssc.larsentoubro.com/';
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }
}
